import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M53.33 29.333H20.878l14.907-14.906-3.787-3.76L10.664 32l21.333 21.333 3.76-3.76-14.88-14.906h32.454z" }));
export {
  a as default
};
